import { gql } from "@apollo/client";

export const GET_PRECIOS_CONTROL = gql`
query GetPreciosControl ($filter: AutorizacionCambioPrecioFilterInput!) {
    preciosControl(filter: $filter) {
        success
        error
        valorEsperado {
            idAutorizacionControl
            periodo
            precioControl
            precioACambiar
            evento
            region
            delegacion
            solicitante
            fecha
            financiador
            contrato
            codigo
            modulo
            idMinuta
        }
    }
}`;

export const AdaptPreciosControl = (data) => {
  if (!data) return null;
  const { preciosControl } = data;
  if (preciosControl?.error) return null;
  if (!preciosControl?.success) return null;
  return preciosControl?.valorEsperado || [];
};